

<mat-form-field class="user-full-width">
  <mat-label>Phase</mat-label>
  <mat-select [disabled]="disabled" [(value)]="phase">
    @for (p of phases; track p) {
      <mat-option [value]="p">{{p}}</mat-option>
    }
  </mat-select>
</mat-form-field>